export default [
  {
    name: 'Discord',
    icon: 'discord',
    color: '#5865F2',
    isDark: true,
    ref: 'discord',
  },
];
